/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const ArrowUpIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
    >
      <path
        d="M10.0406 4.93837L16.5455 11.4432C16.8898 11.7854 17.3555 11.9775 17.8409 11.9775C18.3264 11.9775 18.7921 11.7854 19.1364 11.4432C19.3086 11.2724 19.4453 11.0692 19.5386 10.8452C19.6319 10.6213 19.6799 10.3811 19.6799 10.1386C19.6799 9.89599 19.6319 9.65581 19.5386 9.43189C19.4453 9.20798 19.3086 9.00474 19.1364 8.83392L11.3453 1.04282C11.1745 0.870591 10.9712 0.73389 10.7473 0.640601C10.5234 0.547313 10.2832 0.499282 10.0406 0.499282C9.79806 0.499282 9.55789 0.547312 9.33397 0.640601C9.11005 0.73389 8.90682 0.870591 8.73599 1.04282L0.853016 8.83392C0.682712 9.00562 0.547975 9.20925 0.456531 9.43313C0.365087 9.657 0.318733 9.89673 0.320131 10.1386C0.318733 10.3804 0.365087 10.6201 0.456531 10.844C0.547975 11.0679 0.682712 11.2715 0.853015 11.4432C1.1973 11.7854 1.66302 11.9775 2.14847 11.9775C2.63392 11.9775 3.09964 11.7854 3.44392 11.4432L10.0406 4.93837Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
